//
import ModelForm from '../model-form'

//
export default {
    components: {
        ModelForm,
    },
    computed: {
        /**
         *
         */
        formProps() {
            return {
                fields: this.items.map(this.mapField),
                submitBlock: false,
                //submitDivider: false,
            }
        },
    },
    data() {
        return {
            formData: {},
        }
    },
    methods: {
        /**
         *
         */
        mapField(item) {
            return {
                name: item.name || 'name',
                type: item.type || 'text-field',
                flex: {
                    ...(item.flex || { sm3: true }),
                },
                props: {
                    class: 'my-2 elevation-1',
                    ...item.props,
                    flat: true,
                    hideDetails: true,
                    outline: false,
                    solo: true,
                },
                trigger: item.trigger,
            }
        },

        /**
         *
         */
        reset() {
            this.formData = {}
            this.$emit('submit', {})
        },

        /**
         *
         */
        submit(event) {
            this.$emit('submit', event)
        },
    },
    props: {
        /**
         *
         */
        items: {
            type: Array,
            default: () => [],
        },

        initialValues: {
            type: Object,
            default: () => ({}),
        },
    },
    mounted() {
        //this.filter=this.initialValues||{}
    },
    watch: {
        initialValues: {
            immediate: true,
            handler(v = {}) {
                this.formData = v || {}
            },
        },
    },
}
